import type {
  Money,
  Product,
  SelectedOptions,
} from "@/configurator/domain/models/types";
import { getSelectedOptionIds } from "./selection";

const ZERO: Money = { amount: 0, currency: "CZK" };

/**
 * Sum of the surcharges of the options selected right now, so the price follows
 * the configuration instead of staying at the base price.
 */
export function getSelectedOptionsPrice(
  product: Product,
  selected: SelectedOptions,
): number {
  let total = 0;
  for (const group of product.optionGroups) {
    const selectedIds = getSelectedOptionIds(group, selected);
    for (const option of group.options) {
      if (selectedIds.includes(option.id)) total += option.price ?? 0;
    }
  }
  return total;
}

/** Price of one configured unit: base plus the surcharges selected on it. */
export function getUnitPrice(
  product: Product | undefined,
  selected: SelectedOptions,
): Money {
  if (!product) return ZERO;
  return {
    ...product.basePrice,
    amount:
      product.basePrice.amount + getSelectedOptionsPrice(product, selected),
  };
}

export function getTotalPrice(
  product: Product | undefined,
  selected: SelectedOptions,
  quantity: number,
): Money {
  const unit = getUnitPrice(product, selected);
  return { ...unit, amount: unit.amount * quantity };
}
